import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import {connect} from 'react-redux';
import {useQuery} from '@apollo/client';

import SegmentHeader from '@appComponents/SegmentHeader';
import {createForm} from '@utils/forms';
import {getLink, Link} from '@appComponents/Link';
import {CircleButtonAdd} from '@appComponents/ButtonCollection';
import {Authorization} from '@appComponents/Authorization';
import {ENCODING_TARGET} from '@constants/resources';
import {SECURITY_PRIVILEGES_READ_UPDATE} from '@constants/variables';
import {routes} from '@constants/routes';
import {convertToInt, isUrlParamValid} from '@utils/helpers';
import {GetThirdPartyClientCdnConfigurationsForEventContent} from '@graphql/thirdPartyClients/query';
import {showModal} from '@utils/modal';

import EventsConfigurationCdnConfigurationsTable from '../components/EventsConfigurationCdnConfigurationsTable';
import EventContentCdnConfigurationModel from '../forms/EventContentCdnConfigurationModel';
import EventContentCdnConfigurationForm from '../forms/EventContentCdnConfigurationForm';
const authorizationEncodingTargetReadUpdateObject = {
    [ENCODING_TARGET]: SECURITY_PRIVILEGES_READ_UPDATE,
};

const EventsConfigurationCdnConfigurations = (props) => {
    const {
        distributions,
        eventContentId,
        history,
        match,
    } = props;

    const {
        data: {
            eventContentThirdPartyClientCdnConfigurations = [],
        } = {},
        loading: loadingThirdPartyClientCdnConfigurations = true,
    } = useQuery(GetThirdPartyClientCdnConfigurationsForEventContent, {
        variables: {
            eventContentId: eventContentId,
        },
        fetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (match.path === routes.events.configuration.content.cdnConfiguration.add.path && convertToInt(match.params.contentId) === eventContentId && isUrlParamValid(match.params.id) && isUrlParamValid(match.params.contentId)) {
            const FormComponent = createForm(EventContentCdnConfigurationModel, EventContentCdnConfigurationForm, {
                optionsVariables: {
                    eventId: convertToInt(match.params.id),
                    eventContentId,
                }, isAddForm: true, distributions, eventContentThirdPartyClientCdnConfigurations,
            });
            showModal({
                header: false,
                isVisible: true,
                content: <FormComponent/>,
                onClose: () => {
                    if (match.path !== routes.events.configuration.index.path) {
                        history.push(getLink('events.configuration.index', {id: match.params.id}));
                    }
                },
            });
        }
    }, [match.path, match.params.contentId, eventContentId, distributions, eventContentThirdPartyClientCdnConfigurations, match.params.id, history]);

    const renderAddButton = () => (<Authorization authorization={authorizationEncodingTargetReadUpdateObject}>
        <Link
            name='events.configuration.content.cdnConfiguration.add'
            params={{
                id: match.params.id, contentId: eventContentId,
            }}>
            <CircleButtonAdd/>
        </Link>
    </Authorization>);

    return (
        <div>
            <SegmentHeader buttons={renderAddButton()}> Client CDN configurations </SegmentHeader>
            <div className='--table'>
                <EventsConfigurationCdnConfigurationsTable
                    loading={loadingThirdPartyClientCdnConfigurations}
                    eventContentThirdPartyClientCdnConfigurations={eventContentThirdPartyClientCdnConfigurations}
                />
            </div>
        </div>
    );
};

EventsConfigurationCdnConfigurations.propTypes = {
    distributions: PropTypes.array.isRequired,
    eventContentId: PropTypes.number.isRequired,
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    propertyLicenceId: convertToInt(state.app.entities.event.property_licence.id),
});

export default withRouter(connect(mapStateToProps)(EventsConfigurationCdnConfigurations));
